import { writable } from "svelte/store";

export type ModalKind = "confirm" | "prompt";

export type ModalRequest = {
  kind: ModalKind;
  title: string;
  message?: string;
  value?: string;
  placeholder?: string;
  confirmLabel?: string;
  resolve: (value: boolean | string | null) => void;
};

export const modal = writable<ModalRequest | null>(null);

function open(request: Omit<ModalRequest, "resolve">): Promise<boolean | string | null> {
  return new Promise((resolve) => modal.set({ ...request, resolve }));
}

export async function confirmModal(
  title: string,
  message: string,
  confirmLabel = "Подтвердить",
): Promise<boolean> {
  return (await open({ kind: "confirm", title, message, confirmLabel })) === true;
}

export async function promptModal(
  title: string,
  value = "",
  placeholder = "",
  confirmLabel = "Сохранить",
): Promise<string | null> {
  const result = await open({ kind: "prompt", title, value, placeholder, confirmLabel });
  return typeof result === "string" ? result : null;
}
